import React from 'react';
import css from './awards.module.scss';
import tcp1 from '../../assets/images/extra/med-yassine-ben-khalifa.jpg';
import springChallenge2021 from '../../assets/images/extra/springChallenge2021.png';
import psm1 from '../../assets/images/extra/psm1.png';

export default class Awards extends React.Component {

    render() {
        return (
            <div className={css.container} id='awards'>
                <h1>Awards</h1>
                <div/>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', marginBottom: '1em'}}>
                    {/*<img src={war} alt="" className={css.warImg}/>*/}
                    <div className={css.award} id="psm1">
                        <img src={psm1} alt=""/>
                    </div>

                    <div className={css.award} id="spring_challenge_2021">
                        <img src={springChallenge2021} alt=""/>
                        <h5 className={css.textSectionInfo}>Description:</h5>
                        <p>
                            <a className={css.link}
                               href='https://www.codingame.com/'
                               rel="noopener noreferrer"
                               target='_blank'>CodinGame</a> is a challenge-based training platform for programmers where you can improve your coding skills with fun exercises.
                            <br/>
                            <strong>May 06 to May 17, 2021</strong>, I participated in «<a className={css.link}
                               href='https://www.codingame.com/contests/spring-challenge-2021'
                               rel="noopener noreferrer"
                               target='_blank'>Spring Challenge 2021</a>» and I built an AI using heuristics and
                            <a className={css.link}
                               href='https://en.wikipedia.org/wiki/Monte_Carlo_tree_search'
                               rel="noopener noreferrer"
                               target='_blank'> MCTS</a>.

                            In the end I succeeded to reach
                            <a className={css.link}
                               href='https://www.codingame.com/contests/spring-challenge-2021/leaderboard/global?column=COUNTRY&value=TN'
                               rel="noopener noreferrer"
                               target='_blank'> high gold league</a>.
                        </p>
                    </div>

                    <div className={css.award} id="tcpc">
                        <img src={tcp1} alt=""/>
                        <h5 className={css.textSectionInfo}>Description:</h5>
                        <p>
                            June 23 and 24, 2018, The software engineering school (ENISo) hosted the Tunisian Collegiate
                            Programming Contest (TCPC) and I was happy and proud for being able to help organize such a big
                            and successful event, it was a positive experience especially
                            interacting with dynamic people who helps you surpass your limits.
                        </p>
                    </div>

                </div>

            </div>
        );
    }
}
